<script setup>
import { ref } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({ open: { type: Boolean, default: false } });
const emit = defineEmits(['close', 'import']);

const file = ref(null);
const uploading = ref(false);

function onFile(e) {
  file.value = e.target.files[0];
}
async function submit() {
  if (!file.value) return;
  uploading.value = true;
  try {
    await emit('import', file.value);
    file.value = null;
  } finally {
    uploading.value = false;
  }
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="open"
      class="fixed inset-0 z-50 flex items-center justify-center p-4"
      @click.self="emit('close')"
    >
      <div
        class="absolute inset-0 bg-black/50 backdrop-blur-sm"
        @click="emit('close')"
      />
      <div
        class="relative z-10 w-full max-w-lg rounded-xl bg-n-background p-5 shadow-2xl"
      >
        <div class="mb-3 flex items-center justify-between">
          <h3 class="text-base font-bold text-n-slate-12">
            Importar cabos via CSV
          </h3>
          <Button
            variant="ghost"
            size="sm"
            icon="i-lucide-x"
            @click="emit('close')"
          />
        </div>
        <p class="mb-3 text-xs text-n-slate-11">
          Colunas aceitas (qualquer ordem, cabeçalho obrigatório):
          <code>name</code> (ou <code>nome</code>), <code>phone</code>,
          <code>email</code>, <code>role</code>, <code>city</code>,
          <code>state</code>, <code>neighborhood</code>,
          <code>estimated_votes</code>, <code>notes</code>. Separador: vírgula
          ou ponto-e-vírgula.
        </p>
        <input
          type="file"
          accept=".csv,text/csv"
          class="block w-full rounded-lg border border-dashed border-n-strong/40 bg-n-slate-2 p-4 text-xs"
          @change="onFile"
        />
        <div class="mt-4 flex justify-end gap-2">
          <Button variant="outline" size="sm" @click="emit('close')">
            Cancelar
          </Button>
          <Button
            variant="solid"
            color="blue"
            size="sm"
            :is-loading="uploading"
            :disabled="!file"
            @click="submit"
          >
            Importar
          </Button>
        </div>
      </div>
    </div>
  </Teleport>
</template>
